import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { observable } from 'mobx'
import { once } from 'lodash-es'

export type NotificationPreferencesProps = ModelProps<NotificationPreferences>

/**
 * NotificationPreferences
 */
export class NotificationPreferences extends Model<NotificationPreferences> {
  /**
   * ID of the user the preferences belong to.
   */
  userId = Id.none

  /**
   * ID of the workspace the owner of the preferences belong to.
   */
  workspaceId = Id.none

  /**
   * Global notification preferences; toggles all types.
   */
  @observable accessor media = NotificationMediaPreferences.default()

  /**
   * Preferences per type.
   */
  @observable accessor types = new Map<string, NotificationMediaPreferences>()

  /**
   * Empty instance.
   */
  static get none() {
    return lazyNone()
  }
}

const lazyNone = once(() => new NotificationPreferences())

/**
 * Preferences related to email and push channels.
 */
export interface NotificationMediaPreferences {
  email: NotificationMediumSettings
  push: NotificationMediumSettings
}

export const NotificationMediaPreferences = {
  default: (): NotificationMediaPreferences => ({
    email: NotificationMediumSettings.default(),
    push: NotificationMediumSettings.default(),
  }),
}

/**
 * Settings for the notification medium.
 */
export interface NotificationMediumSettings {
  enabled: boolean
}

export const NotificationMediumSettings = {
  default: (): NotificationMediumSettings => ({
    enabled: false,
  }),
}
